import { Heading, HStack, SimpleGrid, Stat, Text } from '@chakra-ui/react';
import { FiZap } from 'react-icons/fi'
import { Card } from '../shared/Card'
import type { ContactAnalyticsFlag, ImpactScore } from '../../types/contactDetail'

interface ImpactSectionProps {
  /**
   * Accepted for call-site compatibility and deliberately UNUSED. Since MQ-9/DT-12 the
   * flags render once, at the name level, and FlagLegend (under the badge row in
   * ContactProfileHeader) owns their explanations — which also makes them reachable in
   * the contact detail MODAL, where this section is not rendered at all.
   */
  flags?: ContactAnalyticsFlag[]
  impactScores: ImpactScore[]
}

/**
 * The slice-3 hero card: three impact scores. Explainability now lives in FlagLegend
 * ("Counts toward: GOTV · Primary"), adjacent on the page — this card carries only the
 * per-score contributing-flag COUNT, so no flag is chipped more than once.
 */
export function ImpactSection({ impactScores }: ImpactSectionProps) {
  const hasScores = impactScores.some((s) => s.score > 0)
  if (!hasScores) return null

  return (
    <Card>
      <HStack mb={4} gap={2}>
        <FiZap color="var(--chakra-colors-accent)" />
        <Heading size="md">Impact</Heading>
      </HStack>

      <SimpleGrid columns={{ base: 1, md: 3 }} gap={4}>
        {impactScores.map((s) => (
          <Stat.Root key={s.profileName} borderWidth="1px" borderRadius="md" p={3}>
            <Stat.Label>{s.label}</Stat.Label>
            <Stat.ValueText>{Math.round(s.score)}</Stat.ValueText>
            {s.contributingFlagKeys.length > 0 && (
              <Text fontSize="xs" color="muted" mt={1}>
                {s.contributingFlagKeys.length} contributing flag{s.contributingFlagKeys.length === 1 ? '' : 's'}
              </Text>
            )}
          </Stat.Root>
        ))}
      </SimpleGrid>
    </Card>
  );
}
